import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public today: number = Date.now();
  public version = environment.version;
  public buildName = environment.buildName;
  constructor() { }
  ngOnInit(): void {
  }
}